module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tableShow) ? _c('div', [_c('h3', {
    staticClass: "title-content mb-5"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('ACTIVATION_CODES')) + "\n    ")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.ordersOnCurrentPage,
      "hide-actions": true,
      "no-data-text": _vm.$t('EMPTY_LIST')
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [(props.item.status.active) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                " + _vm._s(_vm.dateFormat(props.item.activationDate)) + "\n            ")]) : _vm._e(), _vm._v(" "), (!props.item.status.active) ? _c('td', {
          staticClass: "text-xs-left"
        }) : _vm._e(), _vm._v(" "), (props.item.code) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "text-xs-center text-green"
        }, [_vm._v("\n                    " + _vm._s(props.item.code) + "\n                ")])]) : _vm._e(), _vm._v(" "), (props.item.size) ? _c('td', {
          staticClass: "text-xs-left"
        }, [_c('div', {
          staticClass: "text-xs-center"
        }, [_vm._v("\n                    " + _vm._s(props.item.size) + "\n                ")])]) : _vm._e(), _vm._v(" "), (props.item.code && !props.item.status.old) ? _c('td', {
          staticClass: "text-xs-center"
        }, [(!props.item.status.codeSend && props.item.status.active) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('PACKAGE_ACTIVE')) + "\n                ")]) : _vm._e(), _vm._v(" "), (props.item.status.codeSend) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('CODE_SENT')) + "\n                ")]) : _vm._e(), _vm._v(" "), (!props.item.status.active && !props.item.status.codeSend) ? _c('div', {
          staticClass: "text-xs-center"
        }, [_c('button', {
          staticClass: "app-btn app-btn--small app-btn-default",
          on: {
            "click": function($event) {
              return _vm.showWindowModal(props.item)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$t('ACTIVATE_PACKAGE')) + "\n                    ")]), _vm._v(" "), _c('br'), _vm._v(" "), (!props.item.status.onlyActive) ? _c('span', {
          staticClass: "link--small",
          on: {
            "click": function($event) {
              return _vm.showWindowModalSend(props.item)
            }
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.$t('OR_SEND_CODE')) + "\n                    ")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (props.item.code && props.item.status.old) ? _c('td', {
          staticClass: "text-xs-center"
        }, [_c('span', [_vm._v("\n                    " + _vm._s(_vm.$t('OVERDUE_PACKAGE')) + "\n                ")])]) : _vm._e(), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v("\n                " + _vm._s(props.item.expireDate) + "\n            ")])]
      }
    }], null, false, 413886557)
  }), _vm._v(" "), (_vm.numberOfPages > 1) ? _c('div', [_c('v-pagination', {
    attrs: {
      "length": _vm.numberOfPages,
      "total-visible": _vm.numberOfTotalVisiblePages,
      "prev-icon": "arrow_back",
      "next-icon": "arrow_forward"
    },
    model: {
      value: (_vm.currentlyDisplayedPage),
      callback: function($$v) {
        _vm.currentlyDisplayedPage = $$v
      },
      expression: "currentlyDisplayedPage"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('modal', {
    on: {
      "close": _vm.closeModal
    }
  }, [(_vm.isPackageActive()) ? _c('activate-another-package', {
    attrs: {
      "activepackage": this.choosemItem
    },
    on: {
      "close": _vm.closeModal,
      "activate": _vm.activatePackage
    }
  }) : _c('activate-package', {
    attrs: {
      "activepackage": _vm.getChoosenPackage()
    },
    on: {
      "close": _vm.closeModal,
      "activate": _vm.activatePackage
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sendPackageModal) ? _c('modal', {
    on: {
      "close": _vm.closeModal
    }
  }, [_c('send-package', {
    attrs: {
      "activepackage": this.choosemItem
    },
    on: {
      "close": _vm.closeModal,
      "sendPackage": _vm.sendPackage
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rotate-phone mobile"
  }, [_c('p', {
    staticClass: "rotate-phone__text"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ROTATE_PHONE')) + "\n        ")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-750c0724","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/activation-codes/activation-codes.vue
// module id = 1220
// module chunks = 0